export const state = () => ({});

export const mutations = {};

export const getters = {};

export const actions = {
	async emailPasswordResetLink(state: any, payload: any) {
		await this.$axios.get('sanctum/csrf-cookie');

		return new Promise((resolve, reject) => {
			this.$axios
				.post('forgot-password', payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async resetPassword(state: any, payload: any) {
		await this.$axios.get('sanctum/csrf-cookie');

		return new Promise((resolve, reject) => {
			this.$axios
				.post('reset-password', payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
